import React from 'react'
import { Button, Header, List, Icon, Form,label, Input,  Modal, Dropdown , TextArea, Rating} from 'semantic-ui-react'

const ModalMetodosPago = ({showModal, closeModal, strings, paises, errors, onChange,  datos, comentarioLength, saveComentario, onChangeRate}) => (
  <Modal open={showModal}   size='small'>
    <Header icon="write" content="Comentario sobre el curso" />
    <Modal.Content>
       <Header as='h3' color="blue">Deja un breve comentario de lo que te pareció el curso que concluiste</Header>
    
    

            <Form>
                  <TextArea 
                        style={{ minHeight: 100 }}    
                        placeholder={strings?strings["descripcion"]:""} 
                        name="descripcion"
                        onChange={onChange}
                        value={datos.descripcion}
                        icon='edit'/>
                (Limite de caracteres 1000):{datos.descripcion==null?"":(datos.descripcion.length)}
                <br/><br/>
                <label  >Que calificación nos pondrias</label><br/>    
                <Rating icon='star' 
                        defaultRating={3} 
                        rating={datos.calificacion}
                        maxRating={5}
                        onRate={(event, data)=>onChangeRate(event, data)}
                    />

            </Form>
    
    
    </Modal.Content>
    <Modal.Actions>
    {datos.idEstatus==1 || datos.idEstatus==2 || datos.idEstatus==3?                            
        <Button   color='grey'   >
            <Icon name='remove' /> Guardar
        </Button>   
     :
        <Button   color='green' onClick={saveComentario}  >
            <Icon name='remove' /> Guardar
        </Button>
    }
      <Button   color='red' onClick={closeModal}  >
        <Icon name='remove' /> Cerrar
      </Button>
       
    </Modal.Actions>
  </Modal>
)

export default ModalMetodosPago